// extracted by mini-css-extract-plugin
export default {"saleDefaultColor":"#ff784b","saleDefaultSecondaryColor":"#fbf0e9","sale-icon-container":"ixuiwH","saleIconContainer":"ixuiwH"};